const createActions = Object.freeze([
    "create",
    "new",
]);

const getActions = Object.freeze([
    "get",
    "read",
    "show",
]);

const updateActions = Object.freeze([
    "edit",
    "update",
    "change",
]);

const deleteActions = Object.freeze([
    "delete",
    "remove",
]);

const listActions = Object.freeze([
    "index",
    "list",
]);

const crudActions = Object.freeze([
    ...createActions,
    ...getActions,
    ...updateActions,
    ...deleteActions,
]);

const readOnlyActions = Object.freeze([
    ...getActions,
    ...deleteActions,
]);

function isValidCrudAction(action) {
    return crudActions.includes(action);
}

function isValidCreateAction(action) {
    return createActions.includes(action);
}

function isValidGetAction(action) {
    return getActions.includes(action);
}

function isValidUpdateAction(action) {
    return updateActions.includes(action);
}

function isValidDeleteAction(action) {
    return deleteActions.includes(action);
}

function isValidListAction(action) {
    return listActions.includes(action);
}

function isValidReadonlyAction(action) {
    return readOnlyActions.includes(action);
}

function isIllegalCrudAction(action) {
    return !isValidCrudAction(action);
}

function isIllegalCreateAction(action) {
    return !isValidCreateAction(action);
}

function isIllegalGetAction(action) {
    return !isValidGetAction(action);
}

function isIllegalDeleteAction(action) {
    return !isValidDeleteAction(action);
}

function isIllegalListAction(action) {
    return !isValidListAction(action);
}

function isIllegalUpdateAction(action) {
    return !isValidUpdateAction(action);
}

function isIllegalReadonlyAction(action) {
    return !isValidReadonlyAction(action);
}

function throwOnIllegalCrudAction(action) {
    if(isIllegalCrudAction(action)) {
        throw new RangeError(`Illegal value for 'CRUD' action ('${action}'), must be one of: ${crudActions.join(", ")}.`);
        
    }
}

function throwOnIllegalCreateAction(action) {
    if(isIllegalCreateAction(action)) {
        throw new RangeError(`Illegal value for 'Create' action ('${action}'), must be one of: ${createActions.join(", ")}.`);
        
    }
}

function throwOnIllegalGetAction(action) {
    if(isIllegalGetAction(action)) {
        throw new RangeError(`Illegal value for 'Get' action ('${action}'), must be one of: ${getActions.join(", ")}.`);
    }
}


function throwOnIllegalDeleteAction(action) {
    if(isIllegalDeleteAction(action)) {
        throw new RangeError(`Illegal value for 'Delete' action ('${action}'), must be one of: ${deleteActions.join(", ")}.`);
    }
}

function throwOnIllegalListAction(action) {
    if(isIllegalListAction(action)) {
        throw new RangeError(`Illegal value for 'List' action ('${action}'), must be one of: ${listActions.join(", ")}.`);
    }
}

function throwOnIllegalUpdateAction(action) {
    if(isIllegalUpdateAction(action)) {
        throw new RangeError(`Illegal value for 'Update' action ('${action}'), must be one of: ${updateActions.join(", ")}.`);
    }
}

function throwOnIllegalReadonlyAction(action) {
    if(isIllegalReadonlyAction(action)) {
        throw new RangeError(`Illegal value for 'Update' action ('${action}'), must be one of: ${readOnlyActions.join(", ")}.`);
    }
}

export default {
    createActions,
    getActions,
    updateActions,
    deleteActions,
    listActions,
    crudActions,
    isValidCrudAction,
    isValidCreateAction,
    isValidGetAction,
    isValidDeleteAction,
    isValidUpdateAction,
    isValidReadonlyAction,
    isIllegalCreateAction,
    isIllegalCrudAction,
    isIllegalDeleteAction,
    isIllegalGetAction,
    isIllegalListAction,
    isIllegalReadonlyAction,
    throwOnIllegalCreateAction,
    throwOnIllegalCrudAction,
    throwOnIllegalDeleteAction,
    throwOnIllegalGetAction,
    throwOnIllegalListAction,
    throwOnIllegalUpdateAction,
    throwOnIllegalReadonlyAction,
};